import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Layout } from 'antd';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import UsersList from './components/UsersList';
import UsersFilters from './components/UsersFilters';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';

class UserList extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const view_parent_access = views_permissions['view://UserManagement/User_list'];
        const user_create_access = views_permissions['view://UserManagement/User_create'];
        const user_profile_access = views_permissions['view://UserManagement/User_profile'];

        if (!view_parent_access) {
            return <NotFound />;
        }

        return (
            <Layout>
                <Row>
                    <Col span={24}>
                        <div>
                            <h3 className="page-title">Users</h3>
                            <h3 className="page-subhead subhead">Manage users for the Super Bike Factory platform</h3>
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                    <Col span={21}>
                        <UsersFilters />
                    </Col>
                    <Col span={3}>
                        <div style={{ marginTop: 5 }}>
                            <Button disabled={!user_create_access} variant="contained" color="primary" size="small" style={{ float: 'right' }}>
                                <Link style={{ color: '#fff' }} to="/UserManagement/User_create">Add User</Link>
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <UsersList user_profile_access={!user_profile_access} />
                    </Col>
                </Row>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    views_permissions: state.App.Permissions.views_permissions,
});

const urls = ['view://UserManagement/User_list', 'view://UserManagement/User_create', 'view://UserManagement/User_profile', 'view://UserManagement/User_group_create'];


export default connect(mapStateToProps)(checkPermissionsHOC(UserList, urls));



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/index.js